import React, { FC } from 'react'
import { Grid, GridSize, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { lineClamp } from '@src/styles/utils/lineClamp'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => ({
  borderBottom: { borderBottom: `1px solid ${theme.palette.grey[300]}` },
  link: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  firstColumn: {
    ...lineClamp(2),
  },
}))

const ContentRow: FC<{
  loading?: boolean
  firstColumn: React.ReactNode
  firstColumnWidth?: GridSize
  onClick?: () => void
  secondColumn?: React.ReactNode
}> = ({
  loading = false,
  firstColumn,
  firstColumnWidth = 6,
  onClick = () => {
    // Added comment for avoid es-lint error
  },
  secondColumn,
}) => {
  const classes = useStyles()

  return (
    <Grid
      className={
        loading || !secondColumn
          ? classes.borderBottom
          : clsx(classes.borderBottom, classes.link)
      }
      item
      container
      onClick={() => onClick()}
      xs={12}
    >
      {!secondColumn ? (
        <Grid item xs={12}>
          {firstColumn}
        </Grid>
      ) : (
        <>
          <Grid
            item
            xs={12}
            lg={firstColumnWidth as GridSize}
            className={classes.firstColumn}
          >
            {firstColumn}
          </Grid>
          <Grid
            item
            xs={12}
            lg={(12 - (firstColumnWidth as number)) as GridSize}
          >
            {secondColumn}
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default ContentRow
